<template>
  <div class="tour-search-form" v-if="TOUR_ENABLED">
    <div>
      <p class="text-center text-md-left">{{ FORM_DESCRIPTION2 }}</p>
      <form id="formTour">
        <div class="row">
          <div class="col-12 inputPartenza">
            <div class="form-group">
              <label for="partenzaId">Partenza il</label>
              <CustomDatepicker
                id="partenzaId"
                v-model="search.partenza"
                :disabled-dates="disabledDates"
              />
            </div>
          </div>
          <div class="col-12 inputPasseggeri">
            <div class="form-group">
              <label for="passeggeriId">Passeggeri</label>
              <CamereSelector id="passeggeriId" v-model="search.camere" />
            </div>
          </div>
          <div v-if="isMobile" class="col-12 mt-2">
            <button
              id="creaViaggioTourCrociereMobile"
              type="button"
              class="btn btn-primary orange w-100"
              @click="onClick"
              :disabled="!enabledConfirm"
            >
              crea il tuo viaggio
            </button>
          </div>
        </div>
        <div v-if="!isMobile" class="buttons">
          <button
            id="creaViaggioTourCrociere"
            type="button"
            class="btn btn-primary orange"
            @click="onClick"
            :disabled="!enabledConfirm"
          >
            crea il tuo viaggio
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import CustomDatepicker from "../../common/CustomDatePicker";
import CamereSelector from "../../common/CamereSelector";
import { PRODUCT_TOUR } from "../../../../types/products";
import { toDateFromServer } from "../../../../utils/formatter";
import { isSameDate } from "../../../../utils/helper";
import AnalyticEvents from "../../../common/AnalyticEvents";
import MobileDetector from "../../../common/MobileDetector";
import ContentUtils from "../../../utils/ContentUtils";

export default {
  name: "TourAccompagnatoSearchForm",
  mixins: [AnalyticEvents, MobileDetector, ContentUtils],
  components: { CamereSelector, CustomDatepicker },
  data: function () {
    return {
      search: {
        product: PRODUCT_TOUR,
        partenza: null,
        camere: [
          {
            adults: 2,
            childs: [],
          },
        ],
      },
    };
  },
  computed: {
    enabledConfirm: function () {
      const { partenza } = this.search;
      return partenza != null;
    },
    dates() {
      const list = this.getTourList();
      let dates = [];
      list
        .filter((tour) => tour.mini === false)
        .forEach((tour) => {
          const tourDates = tour.element.departuresDatePrice.map((item) => {
            return toDateFromServer(item.date.date);
          });
          dates = dates.concat(tourDates);
        });
      return dates;
    },
    disabledDates() {
      if (!this.dates) return [];
      return {
        customPredictor: (date) => {
          const hasDate = this.dates.some((item) => {
            return isSameDate(date, item);
          });
          return !hasDate;
        },
      };
    },
  },
  methods: {
    ...mapGetters(["getSearch", "getTourList"]),
    ...mapActions(["addSearch"]),
    onClick: function () {
      this.trackHomeSearchTour();
      this.addSearch(this.search);
      this.$scrollTo("#app");
      this.$emit("change", PRODUCT_TOUR);
      this.$router.push("/tour-selection");
    },
  },
  created() {
    this.search.partenza = this.dates[0];
  },
};
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/pages/home/TourAccompagnatoSearchForm.vue